import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ResultChartsService {

  generateChartImageRequest: {
    annualGraph: Subject<void>,
    ROIGraph: Subject<void>,
    monthlyGraph: Subject<void>,
    annualPeakPowerGraph: Subject<void>,
  } = {
    annualGraph: new Subject<void>(),
    ROIGraph: new Subject<void>(),
    monthlyGraph: new Subject<void>(),
    annualPeakPowerGraph: new Subject<void>(),
  };

  chartImageGenerated: {
    annualGraph: Subject<Blob>,
    ROIGraph: Subject<Blob>,
    monthlyGraph: Subject<Blob[]>,
    annualPeakPowerGraph: Subject<Blob>,
  } = {
    annualGraph: new Subject<Blob>(),
    ROIGraph: new Subject<Blob>(),
    monthlyGraph: new Subject<Blob[]>(),
    annualPeakPowerGraph: new Subject<Blob>(),
  };

  chartWidth: number = 800;
  chartForPdfHeight: number = 350;

  regularChartHeight: number = 500;

  constructor() {
  }


}
